import api from 'api';

export const loadGalleryTags = api('POST /api/gallery-tags/grid');

export const deleteTagsCategory = api(
  'DELETE /api/gallery-tags-categories/:id'
);
export const createTagsCategory = api('POST /api/gallery-tags-categories');
export const updateTagsCategory = api('PUT /api/gallery-tags-categories/:id');
export const loadTagsCategory = api('GET /api/gallery-tags-categories/:id');
export const loadTagsByCategory = api(
  'GET /api/gallery-tags/getByCategoryName/:name'
);

export const loadGalleryTagsCategories = api(
  'GET /api/gallery-tags/categories'
);
export const addTags = ({ id, tags }) =>
  api(`PUT /api/gallery-tags/categories/${id}`)({ tags });
